// extracted by mini-css-extract-plugin
export default {"externalContestPage":"ExternalContestPage_externalContestPage__8hms0"};